import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhyChooseUs from "./components/WhyChooseUs";
import Specialties from "./components/Specialties";
import Hospitals from "./components/Hospitals";
import Doctors from "./components/Doctors";
import Testimonials from "./components/Testimonials";
import EnquiryForm from "./components/EnquiryForm";
import Contact from "./components/Contact";
import Disclaimer from "./components/Disclaimer";
import Footer from "./components/Footer";
import AllHospitals from "./pages/AllHospitals";
import AllDoctors from "./pages/AllDoctors";
import AllSpecialties from "./pages/AllSpecialties";
import AdminSetup from "./pages/AdminSetup";
import AdminDashboard from "./pages/AdminDashboard";
import SEOHead from "./components/SEOHead";
import ScrollToTop from "./components/ScrollToTop";

const HomePage = () => {
  return (
    <>
      {/* SEO Meta Tags for homepage with self-referencing canonical */}
      <SEOHead 
        title="Curis Path | Affordable Medical Tourism in India - Save up to 70%"
        description="World-class medical care in India at affordable costs. Expert doctors, JCI accredited hospitals. Specializing in Orthopedics, Oncology, Dental & Cosmetic Surgery."
        canonical="/"
      />
      <Header />
      <Hero />
      <WhyChooseUs />
      <Specialties />
      <Hospitals />
      <Doctors />
      <Testimonials />
      <EnquiryForm />
      <Contact />
      <Disclaimer />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hospitals" element={<AllHospitals />} />
          <Route path="/doctors" element={<AllDoctors />} />
          <Route path="/specialties" element={<AllSpecialties />} />
          <Route path="/admin/setup" element={<AdminSetup />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
